import { LoadingOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin } from "antd";
import useCompany from "features/company/hooks/useCompany";
import { storage } from "lib";
import { useEffect, useMemo } from "react";

const { Outlet, useParams, useSearchParams, useNavigate } = require("react-router-dom")

const WebappComponent = ({
    goToMenu = () => { }
}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    // const param = useParams()
    // console.log("searchParams", searchParams.get("token"));
    useCompany()
    useEffect(() => {
        const token = searchParams.get("token")
        const currentEmployee = searchParams.get("currentEmployee")
        const currentCompany = searchParams.get("currentCompany")

        if (token &&
            currentEmployee &&
            currentCompany) {
            // console.log("tokeo2", token, currentEmployee, currentCompany);
            storage.sessionStorage.setItem("auth-token", token);
            storage.sessionStorage.setItem("currentEmployee", currentEmployee);
            storage.sessionStorage.setItem("currentCompany", currentCompany);
            storage.localStorage.setItem("auth-token", token);
            storage.localStorage.setItem("currentEmployee", currentEmployee);
            storage.localStorage.setItem("currentCompany", currentCompany);
            navigate("/webapp/policy")
        } else {
            console.log("กรุณา เข้าสู่ระบบ");
            Modal.info({ content: "กรุณา เข้าสู่ระบบ" })
        }

    }, [])


    return <Flex style={{
        height: "100vh"
    }} vertical={true} justify="center">
        <Spin indicator={<LoadingOutlined spin style={{
            fontSize: 48,
        }} />} />
        {/* <Button
            onClick={() => { goToMenu("policy") }}>
            goToPolicy
        </Button>
        <Button
            onClick={() => { goToMenu("product") }}>
            goToProduct
        </Button>
        <Button
            onClick={() => { goToMenu("detail") }}>
            SeeProductDetail
        </Button>
        <Button
            onClick={() => { goToMenu("transaction") }}>
            SeeTransaction
        </Button>
        <Button
            onClick={() => { goToMenu("verify") }}>
            Seeverify
        </Button>
        <Button
            onClick={() => { goToMenu("consent") }}>
            content letter
        </Button>
        <Button
            onClick={() => { goToMenu("otp") }}>
            sms OTP
        </Button>
        <Button
            onClick={() => { goToMenu("complete") }}>
            go to Complete page
        </Button>
        <Button
            onClick={() => { goToMenu("history") }}>
            go to History
        </Button> */}
    </Flex>
}
export default WebappComponent;